import { hasLocalStorage } from '../../utils/browser';

/**
 * Lightweight console logging for testing Mosaic (Permutive-shaped) events in
 * the browser. All messages start with `psm mosaic: `.
 *
 * Logging is gated behind the same debug switch the rest of PRISM uses, so it
 * is silent in production unless explicitly enabled:
 *   - localStorage: `wmpsm_debug` = "true", or
 *   - query string: any URL containing `wmpsm_debug`.
 */
export const MOSAIC_LOG_PREFIX = 'psm mosaic: ';

export function isMosaicDebugEnabled(): boolean {
  try {
    const localStorageDebugFlag = hasLocalStorage() && window.localStorage.getItem('wmpsm_debug') === 'true';
    const queryStringDebugFlag = typeof window !== 'undefined' && window.location.search.includes('wmpsm_debug');
    return Boolean(localStorageDebugFlag || queryStringDebugFlag);
  } catch {
    return false;
  }
}

/**
 * Local testing override for emitting Mosaic events without the
 * `doppler-mosaic-event` feature flag being enabled server-side. Scoped to
 * Mosaic only (does not affect other flags) and off by default:
 *   localStorage: `wmpsm_mosaic` = "true", or query string containing `wmpsm_mosaic`.
 */
export function isMosaicTestOverrideEnabled(): boolean {
  try {
    const localStorageOverride = hasLocalStorage() && window.localStorage.getItem('wmpsm_mosaic') === 'true';
    const queryStringOverride = typeof window !== 'undefined' && window.location.search.includes('wmpsm_mosaic');
    return Boolean(localStorageOverride || queryStringOverride);
  } catch {
    return false;
  }
}

export function logMosaic(message: string, data?: unknown): void {
  if (!isMosaicDebugEnabled()) {
    return;
  }
  if (data !== undefined) {
    console.log(`${MOSAIC_LOG_PREFIX}${message}`, data);
  } else {
    console.log(`${MOSAIC_LOG_PREFIX}${message}`);
  }
}
